// extracted by mini-css-extract-plugin
export default {"button":"SaveObservationPage_button__tvqgV"};